import type { TaxScenario } from '@/tax/types';
import { useFeatureFlags } from '@/hooks/useFeatureFlags';
import { useStrategyEntitlements } from '@/hooks/useStrategyEntitlements';

/**
 * Who gets the Roth Projection view, on either comparison page: the
 * 'fia_growth_strategies' product flag AND this person's Team Management FIA
 * licence — or a comparison that already carries an FIA strategy, which keeps
 * its chart after the licence is turned off.
 */
export function useRothProjectionGate(scenarios: TaxScenario[]): boolean {
  const { isEnabled } = useFeatureFlags();
  const { entitlements } = useStrategyEntitlements();
  const carriesFia = scenarios.some((s) => (s.input.rothGrowthModel ?? 'straight') !== 'straight');
  return isEnabled('fia_growth_strategies') && (entitlements.fia || carriesFia);
}
